import React from 'react'
import { PrivyProvider } from "@privy-io/react-auth";

import NavbarRouter from './components/navbar/NavbarRouter'
import Main from './pages/main/Main'
import Footer from './components/footer/Footer'

//E~ Added for background implementation
import Background from './components/background/Background'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// Switch refuses to import for some reason
//import { Switch, BrowserRouter, Route, Routes } from 'react-router-dom';
import AvatarPage from './pages/avatar/AvatarPage';
import MintPage from './pages/mint/MintPage';
//import NFZFILPage from './pages/nfzfil/NFZFIL'
import AdminLoginPage from "./pages/adminlogin/AdminLoginPage";
import AdminPage from "./pages/admin/AdminPage";


const App = () => {
  return (
    <PrivyProvider
      appId={process.env.REACT_APP_PRIVY_APP_ID}
      config={{
        loginMethods: ["email", "sms", "google"], // adjust to match dashboard
        appearance: {
          theme: "light",
          accentColor: "#6B46C1", // optional
        },
        embeddedWallets: {
          createOnLogin: "users-without-wallets", // auto-create wallet
        },
      }}
    >
     <BrowserRouter basename='/'>
     <Background />
     <NavbarRouter />
     <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/mint" element={<MintPage />} />
          <Route exact path="/demo" element={<MintPage />} />
          <Route exact path="/avatar" element={<AvatarPage />} />
          <Route exact path="/test" element={<MintPage />} />
          <Route exact path="/admin/login" element={<AdminLoginPage />} />
          <Route exact path="/admin/console" element={<AdminPage />} />
     </Routes>
     <Footer />
     </BrowserRouter>
    </PrivyProvider>
  );
};

export default App;
